import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { McommerceTripDetailCartCancelPurchaseDialogComponent } from 'src/app/components/mcommerce-components/mcommerce-trip-detail-cart-cancel-purchase-dialog/mcommerce-trip-detail-cart-cancel-purchase-dialog.component';

@Component({
  selector: 'app-mcommerce-trip-detail-cart-audit-dialog',
  templateUrl: './mcommerce-trip-detail-cart-audit-dialog.component.html',
  styleUrls: ['./mcommerce-trip-detail-cart-audit-dialog.component.scss']
})
export class McommerceTripDetailCartAuditDialogComponent implements OnInit {

  auditLevelOptions;
  auditTypeOptions;
  levelSelectedValue;
  typeSelectedValue;

  constructor(public dialogRef: MatDialogRef<McommerceTripDetailCartCancelPurchaseDialogComponent>) { 
    this.auditLevelOptions = ['low', 'medium', 'high'];
    this.auditTypeOptions = ['vip', 'other', 'other'];
  }

  ngOnInit() {
  }

}
